module.exports = __webpack_public_path__ + "static/media/DL FRONT.0394a63f.jpg";